import {
  Pagination,
  Modal,
  Table,
  Tooltip,
  SlimButton,
  Input,
  NotFound,
  Typography,
  HeadItemType,
  Icon
} from 'components'
import React, { createRef, useEffect, useMemo, useState } from 'react'
import { formatToPTBRNumber, numberToDecimalString } from 'commons/utils/number'
import { MaterialsProps } from '..'
import useDebounce from 'commons/customHooks/useDebounce'
import { useDispatch, useSelector } from 'store/store'
import { setDefaultParams } from 'store/ProductContext'
import { useLocation, useNavigate } from 'react-router-dom'
import { MaterialsListInterface } from 'store/SalesOrderContext/types/MaterialItemData'
import { deleteItemRascunho } from 'services/draft'
import {
  convertBooleanApiValue,
  toAllFirstLetterUpper,
  isValidDecimalString,
  decimalStringToNumber
} from 'commons/utils/string'
import {
  FormActions,
  FactoryWrapper,
  EmptySize,
  SummaryWrapper,
  SummaryRow,
  SummaryItem,
  TableWrapper,
  DivInput,
  StrategyText,
  IconSpan,
  NotFoundWrapper,
  NotFoundContent,
  ButtonsRow
} from './styles'
import {
  updateAllItems,
  updateItem,
  updateRecords,
  setDuplicateChecked,
  getItems,
  fetchOrderStatistics,
  setPendingRecords,
  setMaterialSearch
} from 'store/SalesOrderContext/salesOrderSlice'
import { useFormContext } from 'react-hook-form'
import { SalesOrderFieldsInterface } from 'container/SalesOrder/interfaces'
import {
  setConfirmedNavigation,
  setShowPrompt
} from 'store/StructuralContext/structuralSlice'
import { TypesValidations } from 'constants/enums'
import { getSelectedRecords } from 'container/SalesOrder/utils'
import { usePermissions } from 'commons/customHooks/useAuth'
import { ActionPerm } from 'components/Structures/Header/constants'
import { ACTIONS_SCREENS, SCREENS } from 'commons/utils/permissions'
import { toast } from 'react-toastify'
import { sumArray } from 'commons/utils/array'
import statusRascunho from 'constants/statusRascunho'

import { theme } from 'styles/theme/hav-theme'

function MaterialsList({
  handleRequestMaterials,
  requestMaterials,
  user,
  handleFieldModified
}: Omit<
  MaterialsProps,
  'setModalMaterialsLimit' | 'hasMaterialsEffected' | 'hasUnsavedOVConfig'
>) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { verifyPermission } = usePermissions()

  const { isYTRA, isHAVAConectaOrder } = useSelector(({ ov }) => ov)
  const { records, pendingRecords, isInternationalOrder } = useSelector(
    (state) => state.salesOrder
  )
  const { defaultParams } = useSelector((state) => state.products)
  const getTotalPages = (recordsLength: number) => Math.ceil(recordsLength / pageIn)
  const pageIn = 20
  const [totalPages, setTotalPages] = useState<number>(getTotalPages(records.length))
  const [currentPage, setCurrentPage] = useState<number>(1)
  const getRecordsKey = (key: number) => (currentPage - 1) * pageIn + (key + 1) - 1
  const [modalDeleteMaterial, setModalDeleteMaterial] = useState<boolean>(false)

  const methods = useFormContext<SalesOrderFieldsInterface>()
  const { setValue } = methods
  const sizesSet = useMemo(() => {
    const memoSet = new Set<string>()
    pendingRecords.forEach(({ tamanhos }) => {
      tamanhos.forEach(({ cd_tamh }) => {
        const t = { size: cd_tamh }
        memoSet.add(JSON.stringify(t))
      })
    })
    return memoSet
  }, [pendingRecords])

  const hasNegativeFeedback = useMemo(
    () => pendingRecords.some((record) => record.ds_moti_repv_anls),
    [pendingRecords]
  )

  const shouldDisable = (action: ActionPerm) => {
    return !verifyPermission(SCREENS.ORDER, action)
  }

  const tableLabels = (): HeadItemType[] => {
    const sizes = [...sizesSet].sort().map((size) => {
      const object: { size: string } = JSON.parse(size)

      return { label: object.size, columnName: object.size }
    })

    const tableHead: HeadItemType[] = [
      { label: '', columnName: '' },
      { label: 'Material', columnName: 'Material' },
      { label: 'Descrição', columnName: 'DescricaoMaterial' },
      { label: 'Cor', columnName: 'Cor' },
      { label: 'Descrição', columnName: 'DescricaoCor' },
      { label: 'Estratégico', columnName: 'Estrategico' },
      { label: 'Fábrica', columnName: 'Fabrica' },
      { label: 'Qtd.', columnName: 'Qtd.' },
      { label: 'Valor (R$)', columnName: 'Valor' },
      { label: 'Desc. (%)', columnName: 'Desc' },
      ...sizes
    ]

    if (hasNegativeFeedback)
      tableHead.splice(7, 0, {
        label: 'Motivo de reprovação',
        columnName: 'MotivoReprovacao'
      })

    return tableHead
  }

  const updateMaterialDiscount = (id: string, discountValue: string) => {
    const [ds_matr, cd_cor, nr_item_pedi_rasc] = id.split('-')

    let material = null

    records.forEach((record) => {
      if (
        record.cd_matr === ds_matr &&
        record.cd_cor === cd_cor &&
        record.nr_item_pedi_rasc === +nr_item_pedi_rasc
      ) {
        material = { ...record, pc_dsct: discountValue }
      }
    })

    if (material !== null)
      dispatch(
        updateItem(material, () => {
          toast.success('Desconto alterado com sucesso.')
          dispatch(fetchOrderStatistics(defaultParams.nr_pedi_rasc as string))
          dispatch(getItems(''))
        })
      )
  }
  const debounceChange = useDebounce(updateMaterialDiscount, 1000)

  const handleDiscountValue = (currentValue: string, value: string): string => {
    const newValue = value.replace('.', ',')

    if (value === '') return '0'
    if (!isValidDecimalString(newValue)) return currentValue

    const valueAsNumber = decimalStringToNumber(newValue)

    if (valueAsNumber > 99.99) {
      return '99,99'
    } else if (valueAsNumber < 0) {
      return '0'
    } else {
      if (newValue.includes(',')) return newValue
      else return valueAsNumber.toString()
    }
  }

  const calcBox = () => {
    const totalBox = pendingRecords.map((item) => {
      return item.qt_tota_item
    })
    return totalBox.reduce(sumArray, 0)
  }
  const calcPars = () => {
    const totalPairs = pendingRecords.map((item) => {
      return item.qt_tota_item_conv
    })
    return totalPairs.reduce(sumArray, 0)
  }
  const calcSelectedPairs = () => {
    const valuesToSum = getSelectedRecords(records).map((item) => {
      return item.qt_tota_item_conv
    })
    return numberToDecimalString(valuesToSum.reduce(sumArray, 0))
  }
  const calcTotal = () => {
    const valuesToSum = pendingRecords.map((item) => item.vl_tota_item || 0)
    return valuesToSum.reduce(sumArray, 0)
  }

  const handleDiscount = (key: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const pending = pendingRecords
    if (
      event.target.name !==
      `pc_dsct-${pending[key].cd_matr}-${pending[key].cd_cor}-${pending[key].nr_item_pedi_rasc}`
    ) {
      return
    }
    const currentValue = pending[key]?.pc_dsct.toString()
    const newValue = handleDiscountValue(currentValue, event.target.value)

    if (currentValue !== newValue) {
      const newRecords = pending.map((record) => {
        if (
          pending[key].cd_matr === record.cd_matr &&
          pending[key].nr_item_pedi_rasc === record.nr_item_pedi_rasc
        ) {
          return {
            ...record,
            pc_dsct: newValue
          }
        }
        return record
      })

      dispatch(setPendingRecords(newRecords))
      dispatch(setDuplicateChecked([false]))
      setValue('fl_dsct_matr', TypesValidations.NO)
      debounceChange(
        `${pending[key].cd_matr}-${pending[key].cd_cor}-${pending[key].nr_item_pedi_rasc}`,
        newValue
      )
    }
  }

  useEffect(() => {
    setTotalPages(getTotalPages(pendingRecords.length))

    const getNewCurrentPage = () => {
      const amountOfPages = Math.ceil(pendingRecords.length / pageIn)
      const realAmountOfPages = amountOfPages < 1 ? 1 : amountOfPages
      return currentPage < realAmountOfPages ? currentPage : realAmountOfPages
    }
    setCurrentPage(getNewCurrentPage())
  }, [records])
  useEffect(() => {
    dispatch(setConfirmedNavigation(false))
  }, [])

  const handleDelete = () => {
    const recordsToDelete = getSelectedRecords(records).map((record) => ({
      nr_item_pedi_rasc: record?.nr_item_pedi_rasc,
      cd_cor: record?.cd_cor
    }))
    const body = {
      nr_pedi_rasc: defaultParams.nr_pedi_rasc as string,
      ds_item_pedi_rasc: recordsToDelete,
      cd_usua_alte: user
    }
    deleteItemRascunho(body).then((data) => {
      if (!data) return

      dispatch(getItems(''))
      setModalDeleteMaterial(false)
    })
  }

  const clearMaterialSearch = () => {
    dispatch(setMaterialSearch(''))
    dispatch(getItems())
  }

  const renderFooter = () => {
    return (
      <SummaryWrapper>
        <div>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              numberOfPages={totalPages}
              numberOfItems={pendingRecords.length}
              itemsPerPage={pageIn}
            />
          )}
        </div>
        <SummaryRow>
          <SummaryItem>
            <span>Volume de pares</span>
            <Typography design="hav-default-03-text">
              {numberToDecimalString(calcPars())}
            </Typography>
          </SummaryItem>
          <SummaryItem>
            <span>Volume de caixas</span>
            <Typography design="hav-default-03-text">
              {numberToDecimalString(calcBox())}
            </Typography>
          </SummaryItem>
          <SummaryItem>
            <span>Valor total</span>
            <Typography design="hav-default-03-text">
              {formatToPTBRNumber(calcTotal())}
            </Typography>
          </SummaryItem>
        </SummaryRow>
      </SummaryWrapper>
    )
  }

  const {
    OUT_MINIMUM_ITEM,
    OUT_MINIMUM_ORDER,
    OUT_OF_STOCK,
    WITHOUT_QUOTA,
    INCOMPATIBLE_FACTORY,
    INCOMPLETE_DATA,
    INCONSISTENT_STATUS
  } = statusRascunho

  const getTooltipLabel = (record: MaterialsListInterface) => {
    if (record.cd_stat_pedi_rasc_item === 20) return 'Volume extra aprovado'
    if (record.ds_moti_repv_anls) return 'Volume extra reprovado'
    if (record.ds_moti_crit === OUT_MINIMUM_ITEM) return 'Indisponível por volume mínimo'
    if (record.ds_moti_crit === OUT_MINIMUM_ORDER) return 'Indisponível por valor mínimo'
    if (record.ds_moti_crit === OUT_OF_STOCK) return 'Indisponível por estoque'
    if (record.ds_moti_crit === WITHOUT_QUOTA) return 'Indisponível por cota'
    if (record.ds_moti_crit === INCOMPATIBLE_FACTORY)
      return 'Fábrica inválida, edite o material e verifique as fábricas disponíveis'
    if (record.ds_moti_crit === INCOMPLETE_DATA)
      return 'Cadastro incompleto, para mais informações consulte o backoffice'
    if (record.ds_moti_crit === INCONSISTENT_STATUS)
      return 'Inconsistência de status de material'
    return 'Rascunho'
  }

  const getTooltipIcon = (record: MaterialsListInterface) => {
    const ICON_SIZE = '15'

    // TODO: Replace magic numbers (status) with status enum
    if (record.cd_stat_pedi_rasc_item === 20)
      return (
        <Icon icon="task-alt" color={theme.colors.alert.success.dark} size={ICON_SIZE} />
      )
    if (record.ds_moti_repv_anls)
      return (
        <Icon icon="cancel" color={theme.colors.alert.danger.dark} size={ICON_SIZE} />
      )
    if (record.ds_moti_crit === OUT_MINIMUM_ITEM)
      return (
        <Icon icon="sandal" color={theme.colors.alert.danger.dark} size={ICON_SIZE} />
      )
    if (record.ds_moti_crit === OUT_MINIMUM_ORDER)
      return <Icon icon="money" color={theme.colors.alert.danger.dark} size={ICON_SIZE} />
    if (record.ds_moti_crit === OUT_OF_STOCK)
      return <Icon icon="box" color={theme.colors.alert.warning.dark} size={ICON_SIZE} />
    if (record.ds_moti_crit === WITHOUT_QUOTA)
      return (
        <Icon icon="report" color={theme.colors.alert.warning.dark} size={ICON_SIZE} />
      )
    if (record.ds_moti_crit === INCOMPATIBLE_FACTORY)
      return (
        <Icon icon="factory" color={theme.colors.alert.warning.dark} size={ICON_SIZE} />
      )
    if (record.ds_moti_crit === INCOMPLETE_DATA)
      return (
        <Icon
          icon="missing-piece"
          color={theme.colors.alert.danger.dark}
          size={ICON_SIZE}
        />
      )
    if (record.ds_moti_crit === INCONSISTENT_STATUS)
      return <Icon icon="swap" color={theme.colors.alert.danger.dark} size={ICON_SIZE} />

    return <Icon icon="edit" color={theme.colors.neutral.light} size={ICON_SIZE} />
  }

  const getRecordsData = () => {
    const recordsData = pendingRecords
      .slice(pageIn * (currentPage - 1), pageIn * currentPage)
      .map((record, key) => {
        const inputs = [...sizesSet].sort().map((size) => {
          const object: { size: string } = JSON.parse(size)
          const foundedSize = record.tamanhos.find((t) => t.cd_tamh === object.size)
          if (foundedSize?.cd_tamh) {
            return record.cd_matr[0] === '7'
              ? numberToDecimalString(foundedSize.qt_item)
              : numberToDecimalString(foundedSize.qt_item_conv)
          }
          return <EmptySize key={`${key}-${object.size}`}>0</EmptySize>
        })
        const inputRef = createRef<HTMLInputElement>()
        const handleClick = () => {
          inputRef.current!.select()
          inputRef.current!.setSelectionRange(0, inputRef.current!.value.length)
        }
        const discountField = () => {
          return (
            <DivInput
              key={`${record.cd_matr}-${record.cd_cor}-${record.nr_item_pedi_rasc}`}
            >
              <Input
                ref={inputRef}
                width={60}
                height={25}
                name={`pc_dsct-${record.cd_matr}-${record.cd_cor}-${record.nr_item_pedi_rasc}`}
                value={record.pc_dsct.toString().replace('.', ',')}
                InputProps={{
                  placeholder: '0'
                }}
                onClick={handleClick}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleDiscount(getRecordsKey(key), event)
                  handleFieldModified()
                }}
                disabled={isYTRA || isHAVAConectaOrder || isInternationalOrder}
              />
            </DivInput>
          )
        }

        const tableContent = [
          <Tooltip
            key={`icon-${record.cd_matr}-${record.cd_cor}`}
            title={getTooltipLabel(record)}
            placement="top"
            arrow
          >
            <IconSpan>{getTooltipIcon(record)}</IconSpan>
          </Tooltip>,
          record.cd_matr,
          toAllFirstLetterUpper(record.ds_matr),
          record.cd_cor,
          toAllFirstLetterUpper(record.ds_cor),
          record.fl_matr_estt === TypesValidations.YES ? (
            <StrategyText>Sim</StrategyText>
          ) : (
            'Não'
          ),
          <FactoryWrapper key={`${record.cd_cent_matr}-${key}`}>
            {record.cd_cent_matr ?? '--'}
          </FactoryWrapper>,
          numberToDecimalString(record.qt_tota_item_conv),
          record.vl_tota_item ? formatToPTBRNumber(record.vl_tota_item) : '-',
          discountField(),
          ...inputs
        ]

        if (hasNegativeFeedback) {
          tableContent.splice(7, 0, record.ds_moti_repv_anls ?? '-')
        }

        return {
          id: `${record.cd_matr}-${record.cd_cor}-${record.nr_item_pedi_rasc}`,
          checked: convertBooleanApiValue(record.fl_sele),
          onDoubleClick: () => {
            dispatch(setConfirmedNavigation(true))
            dispatch(
              setDefaultParams({
                ...defaultParams,
                nr_item_pedi_rasc: record.nr_item_pedi_rasc,
                cd_cent_matr: record.cd_cent_matr
              })
            )
            navigate(`${pathname}/${record.cd_matr}`)
            dispatch(setShowPrompt(false))
          },
          content: tableContent
        }
      })
    return recordsData
  }

  const actionRow = () => {
    return (
      <FormActions>
        <ButtonsRow>
          <SlimButton
            id="material-request-button"
            content="Solicitar"
            type="button"
            variant="primary"
            icon={<Icon icon="send" size="15" />}
            loading={requestMaterials.loading}
            disabled={
              getSelectedRecords(records).length === 0 ||
              shouldDisable(ACTIONS_SCREENS.REQUEST)
            }
            onClick={() => handleRequestMaterials()}
          />
          <SlimButton
            id="material-delete-button"
            content="Excluir"
            type="button"
            variant="secondary"
            icon={<Icon icon="trash" size="15" />}
            disabled={
              getSelectedRecords(records).length === 0 ||
              shouldDisable(ACTIONS_SCREENS.EDIT)
            }
            loading={requestMaterials.loading}
            onClick={() => setModalDeleteMaterial(true)}
          />
        </ButtonsRow>
        <Typography design="hav-default-03-text">
          {getSelectedRecords(records).length > 0
            ? `${calcSelectedPairs()} pares selecionados`
            : 'Nenhum par selecionado'}
        </Typography>
      </FormActions>
    )
  }

  function updateCheck(rec: MaterialsListInterface[], code?: string[]) {
    const newRecords: MaterialsListInterface[] = rec.map((record) => {
      if (code && code.includes(record.cd_matr)) {
        return {
          ...record,
          fl_sele: TypesValidations.NO
        }
      }
      return record
    })

    dispatch(updateRecords(newRecords))
  }

  const setMaterialSelection = (checked: boolean, id?: string) => {
    if (id) {
      const [ds_matr, cd_cor, nr_item_pedi_rasc] = id.split('-')

      let material = null

      const newRecords: MaterialsListInterface[] = records.map((record) => {
        if (
          record.cd_matr === ds_matr &&
          record.cd_cor === cd_cor &&
          record.nr_item_pedi_rasc === Number(nr_item_pedi_rasc)
        ) {
          material = {
            ...record,
            fl_sele: checked ? TypesValidations.YES : TypesValidations.NO
          }
          return {
            ...record,
            fl_sele: checked ? TypesValidations.YES : TypesValidations.NO
          }
        }
        return record
      })
      if (material !== null)
        dispatch(updateItem(material, (code) => updateCheck(newRecords, code)))
    } else {
      const newRecords: MaterialsListInterface[] = records.map((record) => {
        // TODO: Replace magic numbers (status) with status enum
        if (record.cd_stat_pedi_rasc_item === 0 || record.cd_stat_pedi_rasc_item === 20) {
          return {
            ...record,
            fl_sele: checked ? TypesValidations.YES : TypesValidations.NO
          }
        }
        return record
      })
      dispatch(
        updateAllItems(
          (code) => updateCheck(newRecords, code),
          checked ? TypesValidations.YES : TypesValidations.NO,
          true
        )
      )
    }
  }

  return (
    <>
      {pendingRecords.length ? (
        <>
          {actionRow()}
          <TableWrapper>
            <Table
              rowHeight={32}
              hasCheckbox
              checkboxSize="small"
              setChecked={setMaterialSelection}
              headData={tableLabels()}
              bodyData={getRecordsData()}
              iconColumns={[0]}
            />
          </TableWrapper>
        </>
      ) : (
        <NotFoundWrapper>
          <NotFound
            title={'Nenhum resultado encontrado'}
            description={
              <NotFoundContent>
                Verifique os critérios utilizados e tente novamente.
                <SlimButton
                  content="Reiniciar busca e filtros"
                  type="button"
                  icon={<Icon icon="chevron-left" size="15" />}
                  variant="white"
                  onClick={clearMaterialSearch}
                />
              </NotFoundContent>
            }
          />
        </NotFoundWrapper>
      )}
      {renderFooter()}

      <Modal
        open={modalDeleteMaterial}
        setOpen={setModalDeleteMaterial}
        title="Excluir Materiais Selecionados"
        description="Após excluir os materiais, você não poderá editá-los novamente. Deseja mesmo excluir?"
        showReturn
        returnText="Cancelar"
        buttonIcon={<Icon icon="trash" size="15" />}
        buttonText="Excluir materiais"
        buttonAction={handleDelete}
      />
    </>
  )
}

export default MaterialsList
